import NavigationBar from './NavigationBar'
import './NavigationBar.css'

export default NavigationBar



// WEBPACK FOOTER //
// ./src/containers/NavigationBar/index.js